import React, { Component } from 'react'
import { withRouter, Link } from "react-router-dom";
import { connect } from 'react-redux';
import _, { isEmpty, get } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FileSaver from 'file-saver';
import moment from 'moment';

import asyncRoute from '../../../../../helpers/hoc/asyncRoute';
import routes from '../../../../../routes';

import { roleCompetetierList, formFields, confirmationMessage, successfullyMessage } from './constant';
import { uploadFileAction, postDspPlatfornCreationAction, getListByIdDspPlatformAction, postDspPlatfornUpdateAction } from '../../../../../actions';
// import { PERMISSION } from '../../../constants/permission';
// import { checkPermission } from '../../../utils/route-auth';
import { handleError, handleFieldError } from '../../../../../utils/form-validation';
// import { sortArray } from '../../../selectors';
import ToastModal from '../../../../../components/ToastModal'
import Input from '../../../../../components/FormElements/Input';
import Select from '../../../../../components/FormElements/Select';
import ModalConfirmation from '../../../../../components/ModalConfirmation';
import { isTenantDemoAdvertiser } from '../../../../../selectors';
import { message } from 'antd';
import { infoMessages } from '../../../../../constants/demo/constant';

const Tabs = asyncRoute(() => import('../../../../../components/Tabs'));
const Card = asyncRoute(() => import('../../../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../../../components/BreadCrumb'));
const Modal = asyncRoute(() => import('../../../../../components/Modal'));



class index extends Component {

    state = {

        form: {},
        touched: {},
        errors: {},
        submited: false,
        confirmationOpen: false,
        confirmationInfo: '',
        logoUrl: '',
        enableToast: false,
        toastStatus: "",
        toastMsg: "",
        confirmationMsg: "",
        inputFileRender: false,
        isDemoAdvertiser: false,

    }
    async componentWillMount() {
        const { tenantId, authToken, userId, getHierarchyListAction, match: {
            params: { id },
        }, } = this.props;

        if (id) {
            this.editId();
        }


    }

    componentDidMount() {
        this.updateIsDemoAdvertiser();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tenantId !== this.props.tenantId) {
            this.updateIsDemoAdvertiser();
        }
    }

    updateIsDemoAdvertiser = () => {
        const { tenantId } = this.props;
        const isDemoAdvertiser = isTenantDemoAdvertiser(tenantId);
        this.setState({ isDemoAdvertiser });
    };


    handleChange = (e) => {

        let { form } = this.state;

        let { value, name } = e.target;
        form[name] = value;
        this.setState({ form });

    };
    handleTouch = (e) => {
        let { touched, form, errors } = this.state;
        let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    };


    // confirmationCallBack = (success, info) => {
    //     const { confirmationOpen } = this.state;
    //     if (success && info.action.type === 'Confirmation') {
    //         this.setState({ confirmationOpen: !confirmationOpen }, async () => {
    //             await this.handleSave();
    //         });
    //     } else if (info.action.type === 'Success') {
    //         this.setState({ confirmationOpen: !confirmationOpen }, () => {
    //             const { history } = this.props;
    //             history.push('/' + routes.mainRoute + '/' + routes.containers.mediaPlan);
    //         });
    //         // return;
    //     }


    //     this.setState({ confirmationOpen: false });
    // };
    toggleAlertModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation })
    }


    filesUpload = async (e, index) => {
        const urlName = e.target.name;
        let { uploadFileAction, tenantId } = this.props;
        const { form } = this.state;
        const data = new FormData();

        const blob = e.target.files[0];

        if (blob && blob.type && blob.type.length > 0 && blob.type.toLowerCase().includes('image')) {

            data.append('file', blob, `${new Date().getTime()}${blob.name.split(" ").join('_')}`);

            const response = await uploadFileAction(data, tenantId, 'image');
            if (response && response.responseCode && response.responseCode.status === 'Success') {
                this.setState({ logoUrl: response.responseList })

            } else {
                let info = { action: { confirmationMessage: response.responseCode.desc, type: 'error' } }
                //   this.toggleAlertModal(info);
            }
        }
        else {
            this.toast('error', 'Invalid file type');
        }
    }

    reRenderFileType = () => {
        this.setState({ inputFileRender: true }, () => {
            setTimeout(() => {
                this.setState({ inputFileRender: false })
            }, 100)
        })
    }


    async GenratePayload() {


        if (this.state.isDemoAdvertiser) {
            message.info(infoMessages.platformUpdate);
            return
        }

        const { userId, authToken, tenantId, postDspPlatfornCreationAction, postDspPlatfornUpdateAction, match: {
            params: { id },
        }, } = this.props
        const { form, logoUrl } = this.state
        const payload = {
            platName: form.dspName,
            logoUrl: logoUrl
        }


        if (id) {
            const platformId = id


            var {
                responseCode: { status = "", msg = "" },
                // responseList,
            } = await postDspPlatfornUpdateAction({
                tenantId,
                authToken,
                userId,
                payload,
                platformId
            });
            if (status) {
                this.toast(status, msg)
            }
        } else if (!id) {


            var {
                responseCode: { status = "", msg = "" },
                // responseList,
            } = await postDspPlatfornCreationAction({
                tenantId,
                authToken,
                userId,
                payload,
            });
            if (status) {
                this.toast(status, msg)
            }



        }

    }


    async handleSubmit() {
        const { userId, authToken, tenantId, postDspPlatfornCreationAction } = this.props
        const { form, logoUrl } = this.state

        let { errors, valid, } = handleError(form, formFields);
        if (valid && logoUrl != '') {
            this.setState({ enableToast: true, confirmationMsg: "Are you sure to save?", toastMsg: "", toastStatus: "" });
        } else if (logoUrl == '') {
            this.setState({ enableToast: true, confirmationMsg: "Please Select a Logo", toastMsg: "", toastStatus: "required" });
        } else {
            this.setState({ enableToast: true, toastMsg: "All Fields are Required", toastStatus: "Fail" });
            this.setState({ errors: errors, submited: true });
        }

    }




    editId = async () => {
        const { form, logoUrl } = this.state
        const {
            match: {
                params: { id },
            },
            tenantId,
            authToken,
            ioAdvertisersReport,
            userId,
            getListByIdDspPlatformAction,
        } = this.props;

        if (id) {
            const platformId = id;
            const {
                responseCode: { status = "" },
                responseList,
            } = await getListByIdDspPlatformAction({
                tenantId,
                authToken,
                userId,
                platformId,
            });
            if (status === "Success" && responseList.length > 0) {
                // console.log(responseList,"resposeList")
                form[formFields.dspName.key] = responseList[0].platName
                this.setState({ logoUrl: responseList[0].logoUrl })

                this.setState({ form });

            }
        }
    };





    toast = (status, msg) => {
        this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
    }

    confirmationCallbackModel = (id) => {
        this.setState({ enableToast: false }, () => {
            this.GenratePayload();
        });

    }

    handleToastStatus = (status) => {
        const { match, history } = this.props;
        // console.log("match", match);
        this.setState({ enableToast: status });
        // this rerender for image input because name displaying for not uploaded item in UI >>>>
        this.reRenderFileType();
    }


    deleteFile = (e) => {
        e.preventDefault();
        this.setState({ logoUrl: '' })
    }


    render() {




        const { openModal, errors, form, submited, touched, confirmationInfo, confirmationOpen, logoUrl, enableToast,
            toastMsg,
            toastStatus,
            confirmationMsg, inputFileRender } = this.state;

        const { match: { params: { id } } } = this.props;
        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggalConfirmationModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}





                {
                    enableToast && <ToastModal
                        enableToast={enableToast}
                        status={toastStatus}
                        msg={toastMsg}
                        path={routes.containers.admin + "/" + routes.containers.dataConfig + '/' + routes.dataConfig.dspPlatform.name}
                        idProps={this.props}
                        handleConfirmation={this.confirmationCallbackModel}
                        handleToastStatus={this.handleToastStatus}
                        confirmationMsg={confirmationMsg}
                    />
                }

                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row justify-content-center mt-3">
                            <div className="col-md-12 grid-margin">
                                {/* <Card>
                                    <div className="float-right">
                                        <Link
                                            to={
                                                "/" +
                                                routes.mainRoute +
                                                "/" +
                                                routes.containers.dataConfig + "/" + routes.dataConfig.dspPlatform.name
                                            }
                                        >
                                            <button
                                                type="button"
                                                className="btn btn-primary">
                                                <i className="mdi mdi-keyboard-backspace"></i>Go back
                                            </button>
                                        </Link>
                                    </div>
                                </Card> */}
                                <Card>
                                    <div className='row mt-2'>
                                        <div className="d-flex justify-content-end">
                                            <Link
                                                to={
                                                    "/" +
                                                    routes.mainRoute +
                                                    "/" +
                                                    routes.containers.admin +
                                                    "/" +
                                                    routes.containers.dataConfig + "/" + routes.dataConfig.dspPlatform.name
                                                }
                                            >
                                                <button
                                                    type="button"
                                                    className="btn btn-primary">
                                                    <i className="mdi mdi-keyboard-backspace"></i>Go back
                                                </button>
                                            </Link>
                                        </div>

                                        <div className='col-md-12'>
                                            <Input
                                                onChange={this.handleChange}
                                                onBlur={this.handleTouch}
                                                value={form[formFields.dspName.key]}
                                                setting={formFields[formFields.dspName.key]}
                                                error={errors[formFields.dspName.key]}
                                                submited={submited}
                                                touched={touched[formFields.dspName.key]}
                                            />
                                        </div>

                                        <div className='col-md-12 mt-3'>
                                            <label className=' mt-1 ' style={{ fontSize: '14px' }}>DSP Logo : </label>
                                            {
                                                logoUrl != "" ?
                                                    <>
                                                        {/* <img src={logoUrl} />
                                                        <button onClick={() => {
                                                            this.setState({ logoUrl: "" })
                                                        }}>Delete</button> */}

                                                        <div className='mappedImg'><img src={logoUrl} alt='Platform Logo' />
                                                            <button onClick={(e) => this.deleteFile(e)}>
                                                                <i className="mdi mdi-close text-dark"></i>
                                                            </button>
                                                        </div>
                                                    </>
                                                    :
                                                    !inputFileRender &&
                                                    <input name="url" accept="image/*" className='col-md-12' style={{ position: 'absolute', left: '100px', fontSize: '12px', top: '3px' }}
                                                        onChange={(e) => this.filesUpload(e)} type="file" />


                                            }
                                        </div>




                                        <div className="form-group row mt-5" style={{ width: "100%" }}>
                                            <div className="col-sm-12">
                                                <center>
                                                    <button type="submit" onClick={() => this.handleSubmit()} className="btn btn-primary">Save</button>
                                                    {' '}
                                                    {/* <button type="button" onClick={() => { this.setState({ form: this.reset() }); }} className="btn btn-secondary">Reset</button> */}
                                                    {' '}
                                                    <Link to={'/' + routes.mainRoute + '/' + routes.containers.admin + "/" + routes.containers.dataConfig + "/" + routes.dataConfig.dspPlatform.name}><button type="button" className="btn btn-secondary">Cancel</button></Link>
                                                </center>
                                            </div>
                                        </div>



                                    </div>

                                </Card>
                            </div>

                        </div>
                    </div>
                </div>











            </>
        );
    }
}


export default withRouter(connect(
    (state) => ({

        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', ''),
    }), {
    uploadFileAction,
    postDspPlatfornCreationAction,
    getListByIdDspPlatformAction,
    postDspPlatfornUpdateAction
    //   getAprAction,
    //   getSegmentListAction,
    //   aprDownloadAction,
    //   audienceHierarchylistAction,
    //   getHierarchyListAction,
    //   addAprAction
}
)(index));

index.propTypes = {
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
    getAprAction: PropTypes.func,
    getSegmentListAction: PropTypes.func,
};